class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

(function () {
  function fixCollectionImages() {
    var grid = document.querySelector('#product-grid');
    if (!grid) return;

    grid.querySelectorAll('.card__media img').forEach(function (img, index) {
      var src = img.getAttribute('src');
      if (!src) return;

      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.removeAttribute('loading');
      img.setAttribute('loading', 'eager');
      img.setAttribute('fetchpriority', index < 2 ? 'high' : 'auto');
      img.style.setProperty('display', 'block', 'important');
      img.style.setProperty('opacity', '1', 'important');
      img.style.setProperty('visibility', 'visible', 'important');
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', '100%', 'important');

      if (img.currentSrc !== src) img.src = src;
    });
  }

  function initKimzyCollection() {
    if (!document.querySelector('#product-grid')) return;
    fixCollectionImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKimzyCollection, { once: true });
  } else {
    initKimzyCollection();
  }

  var observer = new MutationObserver(function () {
    initKimzyCollection();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
